export const NamedThemeColors = Object.freeze({
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary',
  Neutral: 'neutral',
  Monochrome: 'monochrome',
} as const)

export type TNamedThemeColor = keyof typeof NamedThemeColors
export type TNamedThemeColorValue =
  (typeof NamedThemeColors)[keyof typeof NamedThemeColors]
